import Button from './Button'

const ButtonPreviewCancelSubmit = ({transIdPreview, transIdCancel, transIdSubmit, onPreview, onCancel, onSubmit, disablePreview = false, disabledCancel = false, disabledSubmit= false}) => (
    <div className={"buttons-submit-cancel"}>
        <Button
            className="button-cancel"
            transId={transIdPreview}
            onClick={onPreview}
            disabled={disablePreview}
            hideText={false}
            type="button"
        />

        <Button
            className="button-cancel"
            transId={transIdCancel}
            onClick={onCancel}
            disabled={disabledCancel}
            hideText={false}
            type="button"
        />

        <Button
            className="button-submit"
            transId={transIdSubmit}
            onClick={onSubmit}
            disabled={disabledSubmit}
            hideText={false}
            type="submit"
        />
    </div>
)

export default ButtonPreviewCancelSubmit